/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';
import Colors from 'constants/Colors';

export const Container = styled.div`
  display: flex;
  padding: 4px 8px;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  border: 1px solid #EEEEEE;
  border-radius: 4px;
  transition: transform 0.2s;
  transform: scale(1);
  width: fit-content;
  gap: 8px;

  ${({ width }) => width && `
    width: ${width};
    max-width: ${width};
  `}

  ${({ height }) => height && `
    height: ${height};
    max-height: ${height};
  `}

  ${({ simulateQuestion }) => simulateQuestion && `
    border: none;
    justify-content: space-around;
    padding: 9px 8px;
  `}
`

export const Title = styled.span`
  font-weight: 700;
  font-size: 12px;
  color: #53565A;
  text-transform: uppercase;
  align-self: center;
`